export const handleNavigate = (key, navigate, role = "tutor") => {
  // Tutor routes
  if (role === "tutor") {
    switch (key) {
      case "dashboard":
        navigate("/tutor/dashboard");
        break;
      case "students":
        navigate("/tutor/students");
        break;
      case "assignments":
        navigate("/tutor/assignments");
        break;
      default:
        break;
    }
    return;
  }

  // Student routes
  if (role === "student") {
    switch (key) {
      case "dashboard":
        navigate("/student");
        break;
      case "analytics":
        navigate("/student/analytics");
        break;
      default:
        break;
    }
  }
};
